<script lang="ts">
	import { canInvest } from '@app/utils/operations';
	import { ButtonBoxPrimary } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { urls } from '@app/urls';
	import { signInUpModalStore } from '@app/stores/signInUpModal';
	import type { ButtonBoxType } from '@wiseed/wikit';
	import { page } from '$app/stores';
	import { hasToDoKYC, hasToUpdateFiscalAddress } from '@app/utils/user';
	import { getUrlKYC } from '@app/utils/kyc';

	export let operation: OperationModel;
	export let props: ButtonBoxType = {};

	$: props = {
		...props,
		label: $t('invest'),
		href: `${
			operation.isQueue && !operation.offer
				? urls.SUBSCRIBE.QUEUE(operation.id.toString())
				: urls.SUBSCRIBE.CONDITIONS(operation.id.toString())
		}`,
		disabled: !canInvest(operation)
	};

	$: hasToAnswerPSFP =
		operation?.investErrors?.some((e) => e.code === 228) ||
		operation?.investErrors?.some((error) => error.code === 237);

	$: hasToAnswerPSI =
		operation?.investErrors?.some((e) => e.code === 229) ||
		operation?.investErrors?.some((e) => e.code === 235) ||
		operation?.investErrors?.some((e) => e.code === 236) ||
		operation?.investErrors?.some((e) => e.code === 234);

	$: mustUpdateProfile = hasToAnswerPSFP || hasToAnswerPSI;
</script>

{#if $page.data?.user}
	{#if hasToDoKYC($page.data?.user)}
		<ButtonBoxPrimary
			props={{
				label: $t('finishRegister'),
				href: getUrlKYC(),
				classNames: props.classNames,
				size: 'default'
			}}
		/>
	{:else if mustUpdateProfile}
		<ButtonBoxPrimary
			props={{
				label: $t('updateProfile'),
				href: hasToUpdateFiscalAddress($page?.data?.user)
					? urls.USER.ACCOUNT.PROFILE
					: hasToAnswerPSFP
						? urls.USER.ACCOUNT.MATCHING_PSFP
						: urls.USER.ACCOUNT.MATCHING_PSI,
				classNames: props.classNames,
				size: 'default'
			}}
		/>
	{:else}
		<ButtonBoxPrimary {props} />
	{/if}
{:else}
	<ButtonBoxPrimary
		props={{ label: $t('nav.header.login'), classNames: props.classNames }}
		on:click={() => {
			signInUpModalStore.open();
		}}
	/>
{/if}
